import { Button, Chip, DropdownItem, DropdownMenu, DropdownTrigger, Progress } from '@heroui/react'
import { Dropdown } from '@heroui/react'
import { type Column, ModelControlEnum } from '@qse/constants'
import { useActiveModelStore } from '@qse/stores'
import { TableComponent } from '@qse/ui'
import { useMemo, useState } from 'react'

import { StatCard } from '../../components'

// Mock data based on the provided API structure
const resellers = [
  {
    id: '123e4567-e89b-12d3-a456-426614174000',
    name: 'Acme Corp',
    description: 'Leading technology solutions provider',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'contact@acmecorp.com',
    contactPerson: 'John Doe',
    phoneNumber: '+1-555-123-4567',
    addressLine1: '123 Main Street',
    addressLine2: 'Suite 100',
    city: 'New York',
    state: 'NY',
    zipcode: '10001',
    countryCode: 'US',
    storagePricePerGbCents: 1000,
    apiCallPriceCents: 10,
    createdAt: '2023-01-01T00:00:00.000Z',
    updatedAt: '2023-01-01T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    // Additional fields for display
    storageLimit: 5000,
    storageUsed: 3200,
    usagePercent: 64,
    lastActive: '2 hours ago',
    totalCustomers: 150,
  },
  {
    id: '456e7890-e89b-12d3-a456-426614174001',
    name: 'TechStart Solutions',
    description: 'Innovative startup technology company',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'info@techstart.com',
    contactPerson: 'Sarah Johnson',
    phoneNumber: '+1-555-234-5678',
    addressLine1: '456 Innovation Drive',
    addressLine2: 'Floor 3',
    city: 'San Francisco',
    state: 'CA',
    zipcode: '94105',
    countryCode: 'US',
    storagePricePerGbCents: 1200,
    apiCallPriceCents: 15,
    createdAt: '2023-02-15T00:00:00.000Z',
    updatedAt: '2023-02-15T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 3000,
    storageUsed: 2100,
    usagePercent: 70,
    lastActive: '1 hour ago',
    totalCustomers: 89,
  },
  {
    id: '789e0123-e89b-12d3-a456-426614174002',
    name: 'Global Enterprises Ltd',
    description: 'International business solutions',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'admin@globalenterprises.com',
    contactPerson: 'Michael Chen',
    phoneNumber: '+1-555-345-6789',
    addressLine1: '789 Business Plaza',
    addressLine2: 'Tower A',
    city: 'Chicago',
    state: 'IL',
    zipcode: '60601',
    countryCode: 'US',
    storagePricePerGbCents: 800,
    apiCallPriceCents: 8,
    createdAt: '2023-03-10T00:00:00.000Z',
    updatedAt: '2023-03-10T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 10000,
    storageUsed: 8500,
    usagePercent: 85,
    lastActive: '30 minutes ago',
    totalCustomers: 320,
  },
  {
    id: '012e3456-e89b-12d3-a456-426614174003',
    name: 'Digital Dynamics',
    description: 'Digital transformation specialists',
    status: 'invited',
    isBillingManaged: true,
    contactEmail: 'hello@digitaldynamics.com',
    contactPerson: 'Emily Rodriguez',
    phoneNumber: '+1-555-456-7890',
    addressLine1: '321 Tech Avenue',
    addressLine2: 'Building B',
    city: 'Austin',
    state: 'TX',
    zipcode: '73301',
    countryCode: 'US',
    storagePricePerGbCents: 1100,
    apiCallPriceCents: 12,
    createdAt: '2023-04-05T00:00:00.000Z',
    updatedAt: '2023-04-05T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 2000,
    storageUsed: 0,
    usagePercent: 0,
    lastActive: 'Never',
    totalCustomers: 0,
  },
  {
    id: '345e6789-e89b-12d3-a456-426614174004',
    name: 'Cloud Connect Pro',
    description: 'Professional cloud services provider',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'support@cloudconnectpro.com',
    contactPerson: 'David Thompson',
    phoneNumber: '+1-555-567-8901',
    addressLine1: '654 Cloud Street',
    addressLine2: 'Suite 200',
    city: 'Seattle',
    state: 'WA',
    zipcode: '98101',
    countryCode: 'US',
    storagePricePerGbCents: 950,
    apiCallPriceCents: 9,
    createdAt: '2023-05-20T00:00:00.000Z',
    updatedAt: '2023-05-20T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 7500,
    storageUsed: 5200,
    usagePercent: 69,
    lastActive: '3 hours ago',
    totalCustomers: 210,
  },
  {
    id: '678e9012-e89b-12d3-a456-426614174005',
    name: 'DataFlow Systems',
    description: 'Advanced data processing solutions',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'contact@dataflowsystems.com',
    contactPerson: 'Lisa Wang',
    phoneNumber: '+1-555-678-9012',
    addressLine1: '987 Data Center Blvd',
    addressLine2: 'Unit 150',
    city: 'Boston',
    state: 'MA',
    zipcode: '02101',
    countryCode: 'US',
    storagePricePerGbCents: 1300,
    apiCallPriceCents: 18,
    createdAt: '2023-06-12T00:00:00.000Z',
    updatedAt: '2023-06-12T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 15000,
    storageUsed: 14200,
    usagePercent: 95,
    lastActive: '15 minutes ago',
    totalCustomers: 450,
  },
  {
    id: '901e2345-e89b-12d3-a456-426614174006',
    name: 'SecureNet Solutions',
    description: 'Cybersecurity and network protection',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'security@securenet.com',
    contactPerson: 'Robert Kim',
    phoneNumber: '+1-555-789-0123',
    addressLine1: '456 Security Lane',
    addressLine2: 'Floor 5',
    city: 'Denver',
    state: 'CO',
    zipcode: '80201',
    countryCode: 'US',
    storagePricePerGbCents: 1400,
    apiCallPriceCents: 20,
    createdAt: '2023-07-08T00:00:00.000Z',
    updatedAt: '2023-07-08T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 8000,
    storageUsed: 4800,
    usagePercent: 60,
    lastActive: '1 day ago',
    totalCustomers: 180,
  },
  {
    id: '234e5678-e89b-12d3-a456-426614174007',
    name: 'MobileFirst Apps',
    description: 'Mobile application development company',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'dev@mobilefirstapps.com',
    contactPerson: 'Amanda Foster',
    phoneNumber: '+1-555-890-1234',
    addressLine1: '789 App Street',
    addressLine2: 'Studio 300',
    city: 'Miami',
    state: 'FL',
    zipcode: '33101',
    countryCode: 'US',
    storagePricePerGbCents: 1050,
    apiCallPriceCents: 11,
    createdAt: '2023-08-15T00:00:00.000Z',
    updatedAt: '2023-08-15T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 4000,
    storageUsed: 2800,
    usagePercent: 70,
    lastActive: '4 hours ago',
    totalCustomers: 95,
  },
  {
    id: '567e8901-e89b-12d3-a456-426614174008',
    name: 'AI Innovations',
    description: 'Artificial intelligence research and development',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'research@aiinnovations.com',
    contactPerson: 'Christopher Lee',
    phoneNumber: '+1-555-901-2345',
    addressLine1: '123 AI Research Park',
    addressLine2: 'Lab Building',
    city: 'Palo Alto',
    state: 'CA',
    zipcode: '94301',
    countryCode: 'US',
    storagePricePerGbCents: 1600,
    apiCallPriceCents: 25,
    createdAt: '2023-09-22T00:00:00.000Z',
    updatedAt: '2023-09-22T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 20000,
    storageUsed: 18500,
    usagePercent: 93,
    lastActive: '45 minutes ago',
    totalCustomers: 600,
  },
  {
    id: '890e1234-e89b-12d3-a456-426614174009',
    name: 'GreenTech Solutions',
    description: 'Sustainable technology solutions',
    status: 'invited',
    isBillingManaged: true,
    contactEmail: 'eco@greentechsolutions.com',
    contactPerson: 'Jennifer Martinez',
    phoneNumber: '+1-555-012-3456',
    addressLine1: '456 Green Avenue',
    addressLine2: 'Eco Building',
    city: 'Portland',
    state: 'OR',
    zipcode: '97201',
    countryCode: 'US',
    storagePricePerGbCents: 900,
    apiCallPriceCents: 7,
    createdAt: '2023-10-10T00:00:00.000Z',
    updatedAt: '2023-10-10T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 1500,
    storageUsed: 0,
    usagePercent: 0,
    lastActive: 'Never',
    totalCustomers: 0,
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174010',
    name: 'FinTech Pro',
    description: 'Financial technology services',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'finance@fintechpro.com',
    contactPerson: 'Daniel Brown',
    phoneNumber: '+1-555-123-4567',
    addressLine1: '789 Finance Street',
    addressLine2: 'Tower 2',
    city: 'Charlotte',
    state: 'NC',
    zipcode: '28201',
    countryCode: 'US',
    storagePricePerGbCents: 1200,
    apiCallPriceCents: 15,
    createdAt: '2023-11-05T00:00:00.000Z',
    updatedAt: '2023-11-05T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 12000,
    storageUsed: 8400,
    usagePercent: 70,
    lastActive: '2 hours ago',
    totalCustomers: 280,
  },
  {
    id: '456e7890-e89b-12d3-a456-426614174011',
    name: 'HealthTech Innovations',
    description: 'Healthcare technology solutions',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'health@healthtechinnovations.com',
    contactPerson: 'Rachel Green',
    phoneNumber: '+1-555-234-5678',
    addressLine1: '321 Health Plaza',
    addressLine2: 'Medical Center',
    city: 'Nashville',
    state: 'TN',
    zipcode: '37201',
    countryCode: 'US',
    storagePricePerGbCents: 1100,
    apiCallPriceCents: 12,
    createdAt: '2023-12-01T00:00:00.000Z',
    updatedAt: '2023-12-01T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 18000,
    storageUsed: 16200,
    usagePercent: 90,
    lastActive: '1 hour ago',
    totalCustomers: 520,
  },
  {
    id: '789e0123-e89b-12d3-a456-426614174012',
    name: 'EduTech Solutions',
    description: 'Educational technology platform',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'education@edutechsolutions.com',
    contactPerson: 'Thomas Wilson',
    phoneNumber: '+1-555-345-6789',
    addressLine1: '654 Education Drive',
    addressLine2: 'Learning Center',
    city: 'Atlanta',
    state: 'GA',
    zipcode: '30301',
    countryCode: 'US',
    storagePricePerGbCents: 850,
    apiCallPriceCents: 8,
    createdAt: '2024-01-15T00:00:00.000Z',
    updatedAt: '2024-01-15T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 6000,
    storageUsed: 3600,
    usagePercent: 60,
    lastActive: '30 minutes ago',
    totalCustomers: 150,
  },
  {
    id: '012e3456-e89b-12d3-a456-426614174013',
    name: 'RetailTech Pro',
    description: 'Retail technology solutions',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'retail@retailtechpro.com',
    contactPerson: 'Nicole Davis',
    phoneNumber: '+1-555-456-7890',
    addressLine1: '987 Retail Avenue',
    addressLine2: 'Shopping Center',
    city: 'Dallas',
    state: 'TX',
    zipcode: '75201',
    countryCode: 'US',
    storagePricePerGbCents: 1000,
    apiCallPriceCents: 10,
    createdAt: '2024-02-10T00:00:00.000Z',
    updatedAt: '2024-02-10T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 9000,
    storageUsed: 6300,
    usagePercent: 70,
    lastActive: '3 hours ago',
    totalCustomers: 220,
  },
  {
    id: '345e6789-e89b-12d3-a456-426614174014',
    name: 'LogisticsTech',
    description: 'Logistics and supply chain technology',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'logistics@logisticstech.com',
    contactPerson: 'Kevin Taylor',
    phoneNumber: '+1-555-567-8901',
    addressLine1: '456 Logistics Way',
    addressLine2: 'Warehouse Complex',
    city: 'Houston',
    state: 'TX',
    zipcode: '77001',
    countryCode: 'US',
    storagePricePerGbCents: 950,
    apiCallPriceCents: 9,
    createdAt: '2024-03-05T00:00:00.000Z',
    updatedAt: '2024-03-05T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 25000,
    storageUsed: 23750,
    usagePercent: 95,
    lastActive: '15 minutes ago',
    totalCustomers: 750,
  },
  {
    id: '678e9012-e89b-12d3-a456-426614174015',
    name: 'MediaStream Pro',
    description: 'Digital media streaming platform',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'media@mediastreampro.com',
    contactPerson: 'Alex Johnson',
    phoneNumber: '+1-555-678-9012',
    addressLine1: '789 Media Street',
    addressLine2: 'Studio Complex',
    city: 'Los Angeles',
    state: 'CA',
    zipcode: '90001',
    countryCode: 'US',
    storagePricePerGbCents: 1300,
    apiCallPriceCents: 18,
    createdAt: '2024-04-01T00:00:00.000Z',
    updatedAt: '2024-04-01T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 30000,
    storageUsed: 28500,
    usagePercent: 95,
    lastActive: '5 minutes ago',
    totalCustomers: 1200,
  },
  {
    id: '901e2345-e89b-12d3-a456-426614174016',
    name: 'GamingTech Solutions',
    description: 'Gaming technology and platform',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'gaming@gamingtechsolutions.com',
    contactPerson: 'Maria Garcia',
    phoneNumber: '+1-555-789-0123',
    addressLine1: '321 Gaming Avenue',
    addressLine2: 'Arcade Building',
    city: 'Las Vegas',
    state: 'NV',
    zipcode: '89101',
    countryCode: 'US',
    storagePricePerGbCents: 1150,
    apiCallPriceCents: 14,
    createdAt: '2024-05-12T00:00:00.000Z',
    updatedAt: '2024-05-12T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 15000,
    storageUsed: 10500,
    usagePercent: 70,
    lastActive: '1 hour ago',
    totalCustomers: 380,
  },
  {
    id: '234e5678-e89b-12d3-a456-426614174017',
    name: 'RealEstateTech',
    description: 'Real estate technology platform',
    status: 'invited',
    isBillingManaged: true,
    contactEmail: 'realestate@realestatetech.com',
    contactPerson: 'James Anderson',
    phoneNumber: '+1-555-890-1234',
    addressLine1: '654 Property Street',
    addressLine2: 'Real Estate Center',
    city: 'Phoenix',
    state: 'AZ',
    zipcode: '85001',
    countryCode: 'US',
    storagePricePerGbCents: 900,
    apiCallPriceCents: 8,
    createdAt: '2024-06-01T00:00:00.000Z',
    updatedAt: '2024-06-01T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 2000,
    storageUsed: 0,
    usagePercent: 0,
    lastActive: 'Never',
    totalCustomers: 0,
  },
  {
    id: '567e8901-e89b-12d3-a456-426614174018',
    name: 'TravelTech Solutions',
    description: 'Travel and tourism technology',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'travel@traveltechsolutions.com',
    contactPerson: 'Sophie Chen',
    phoneNumber: '+1-555-901-2345',
    addressLine1: '987 Travel Way',
    addressLine2: 'Tourism Center',
    city: 'Orlando',
    state: 'FL',
    zipcode: '32801',
    countryCode: 'US',
    storagePricePerGbCents: 1050,
    apiCallPriceCents: 11,
    createdAt: '2024-07-08T00:00:00.000Z',
    updatedAt: '2024-07-08T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 8000,
    storageUsed: 5600,
    usagePercent: 70,
    lastActive: '2 hours ago',
    totalCustomers: 190,
  },
  {
    id: '890e1234-e89b-12d3-a456-426614174019',
    name: 'EnergyTech Pro',
    description: 'Energy management technology',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'energy@energytechpro.com',
    contactPerson: 'Robert Smith',
    phoneNumber: '+1-555-012-3456',
    addressLine1: '456 Energy Street',
    addressLine2: 'Power Center',
    city: 'Philadelphia',
    state: 'PA',
    zipcode: '19101',
    countryCode: 'US',
    storagePricePerGbCents: 1200,
    apiCallPriceCents: 15,
    createdAt: '2024-08-15T00:00:00.000Z',
    updatedAt: '2024-08-15T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 12000,
    storageUsed: 8400,
    usagePercent: 70,
    lastActive: '45 minutes ago',
    totalCustomers: 280,
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174020',
    name: 'LegalTech Solutions',
    description: 'Legal technology platform',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'legal@legaltechsolutions.com',
    contactPerson: 'Amanda White',
    phoneNumber: '+1-555-123-4567',
    addressLine1: '789 Legal Avenue',
    addressLine2: 'Law Center',
    city: 'Washington',
    state: 'DC',
    zipcode: '20001',
    countryCode: 'US',
    storagePricePerGbCents: 1400,
    apiCallPriceCents: 20,
    createdAt: '2024-09-20T00:00:00.000Z',
    updatedAt: '2024-09-20T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 6000,
    storageUsed: 4200,
    usagePercent: 70,
    lastActive: '1 day ago',
    totalCustomers: 120,
  },
  {
    id: '456e7890-e89b-12d3-a456-426614174021',
    name: 'MarketingTech Pro',
    description: 'Digital marketing technology',
    status: 'active',
    isBillingManaged: false,
    contactEmail: 'marketing@marketingtechpro.com',
    contactPerson: 'David Wilson',
    phoneNumber: '+1-555-234-5678',
    addressLine1: '321 Marketing Street',
    addressLine2: 'Ad Center',
    city: 'Minneapolis',
    state: 'MN',
    zipcode: '55401',
    countryCode: 'US',
    storagePricePerGbCents: 1100,
    apiCallPriceCents: 12,
    createdAt: '2024-10-05T00:00:00.000Z',
    updatedAt: '2024-10-05T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 10000,
    storageUsed: 7000,
    usagePercent: 70,
    lastActive: '3 hours ago',
    totalCustomers: 250,
  },
  {
    id: '789e0123-e89b-12d3-a456-426614174022',
    name: 'SportsTech Solutions',
    description: 'Sports technology platform',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'sports@sportstechsolutions.com',
    contactPerson: 'Mike Johnson',
    phoneNumber: '+1-555-345-6789',
    addressLine1: '654 Sports Avenue',
    addressLine2: 'Arena Complex',
    city: 'Kansas City',
    state: 'MO',
    zipcode: '64101',
    countryCode: 'US',
    storagePricePerGbCents: 1000,
    apiCallPriceCents: 10,
    createdAt: '2024-11-01T00:00:00.000Z',
    updatedAt: '2024-11-01T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 7000,
    storageUsed: 4900,
    usagePercent: 70,
    lastActive: '1 hour ago',
    totalCustomers: 180,
  },
  {
    id: '012e3456-e89b-12d3-a456-426614174023',
    name: 'FoodTech Innovations',
    description: 'Food technology and delivery platform',
    status: 'active',
    isBillingManaged: true,
    contactEmail: 'food@foodtechinnovations.com',
    contactPerson: 'Lisa Brown',
    phoneNumber: '+1-555-456-7890',
    addressLine1: '987 Food Street',
    addressLine2: 'Kitchen Complex',
    city: 'San Diego',
    state: 'CA',
    zipcode: '92101',
    countryCode: 'US',
    storagePricePerGbCents: 950,
    apiCallPriceCents: 9,
    createdAt: '2024-12-01T00:00:00.000Z',
    updatedAt: '2024-12-01T00:00:00.000Z',
    createdBy: '123e4567-e89b-12d3-a456-426614174000',
    updatedBy: '123e4567-e89b-12d3-a456-426614174000',
    storageLimit: 5000,
    storageUsed: 3500,
    usagePercent: 70,
    lastActive: '2 hours ago',
    totalCustomers: 95,
  },
]

const columns: Column[] = [
  { name: 'Reseller', uid: 'user' },
  { name: 'Storage Limit', uid: 'storageLimit' },
  { name: 'Usage', uid: 'usage' },
  { name: 'Status', uid: 'status' },
  { name: 'Last Active', uid: 'lastActive' },
  { name: '', uid: 'actions' },
]

const Reseller = () => {
  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
  }

  const handleRowsPerPageChange = (newLimit: number) => {
    setRowsPerPage(newLimit)
    setPage(1) // Reset to first page when changing rows per page
  }

  // Calculate paginated data
  const paginatedData = useMemo(() => {
    const startIndex = (page - 1) * rowsPerPage
    const endIndex = startIndex + rowsPerPage

    return resellers.slice(startIndex, endIndex)
  }, [page, rowsPerPage])

  const totalPages = Math.ceil(resellers.length / rowsPerPage)

  // Calculate totals for stat cards
  const totalResellers = resellers.length
  const activeResellers = resellers.filter(r => r.status === 'active').length
  const totalCustomers = resellers.reduce((sum, r) => sum + r.totalCustomers, 0)
  const totalStorageUsed = resellers.reduce((sum, r) => sum + r.storageUsed, 0)

  const renderCell = (data: any, columnKey: Column['uid']) => {
    const reseller = data

    switch (columnKey) {
      case 'user':
        return (
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 dark:bg-[#E15F781A] flex items-center justify-center text-base font-bold uppercase">
              {reseller.name
                ?.split(' ')
                .map((n: string) => n[0])
                .join('')
                .slice(0, 2)}
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-base font-medium">{reseller.name}</p>
              <p className="text-sm text-gray-600 dark:text-[#AFAFAF]">{reseller.contactEmail}</p>
            </div>
          </div>
        )
      case 'storageLimit':
        return <span>{reseller.storageLimit.toLocaleString()} GB</span>
      case 'usage':
        return (
          <div className="flex flex-col gap-1 min-w-[120px]">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-sm">
                {reseller.storageUsed.toLocaleString()} GB
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Progress
                className="w-24"
                size="sm"
                value={reseller.usagePercent}
                color={
                  reseller.usagePercent > 80
                    ? 'danger'
                    : reseller.status === 'invited'
                      ? 'primary'
                      : 'success'
                }
              />
            </div>
            <div className="text-xs text-[#AFAFAF]">{reseller.usagePercent}% used</div>
          </div>
        )
      case 'status':
        return (
          <Chip
            className="capitalize rounded font-medium"
            size="sm"
            variant="flat"
            style={{
              backgroundColor: reseller.status === 'active' ? '#378A921A' : '#F5A5241A',
              color: reseller.status === 'active' ? '#378A92' : '#F5A524',
            }}
          >
            {reseller.status.charAt(0).toUpperCase() + reseller.status.slice(1)}
          </Chip>
        )
      case 'lastActive':
        return <span>{reseller.lastActive}</span>
      case 'actions':
        return (
          <div className="relative flex justify-end items-center gap-2">
            <Dropdown>
              <DropdownTrigger>
                <Button isIconOnly size="sm" variant="light">
                  <span className="text-2xl">⋮</span>
                </Button>
              </DropdownTrigger>
              <DropdownMenu>
                <DropdownItem key="view">View</DropdownItem>
                <DropdownItem key="edit">Edit</DropdownItem>
                <DropdownItem key="delete">Delete</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        )
      default:
        return reseller[columnKey as keyof typeof reseller]
    }
  }

  return (
    <section className="p-[30px] mt-16 flex flex-col gap-5">
      <div className=" flex justify-between items-center">
        <div>
          <h1 className="font-medium text-2xl">QSE Storage Report</h1>
          <p>See Usage and Quota for your Resellers</p>
        </div>
        <div>
          <Button
            color="primary"
            radius="sm"
            size="lg"
            onPress={() => {
              const config = {
                modalHeader: {
                  title: 'Add New Reseller ',
                  subtitle: 'Please fill the form to create a new Reseller.',
                  showCloseButton: true,
                },
              }

              useActiveModelStore.setState({
                data: config,
                width: 'max-w-[660px]',
                modelActive: ModelControlEnum.ADD_RESELLER,
                toggleModel: true,
                scrollBehavior: 'outside',
              })
            }}
          >
            New Reseller
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-5">
        <StatCard
          iconAlt="resellers"
          iconSrc="/assets/svg/total-resellers.svg"
          label="Total Resellers"
          value={totalResellers.toString()}
        />
        <StatCard
          iconAlt="customers"
          iconSrc="/assets/svg/total-customers.svg"
          label="Total Customers"
          value={totalCustomers.toLocaleString()}
        />
        <StatCard
          iconAlt="storage"
          iconSrc="/assets/svg/total-storage.svg"
          label="Total Storage Used"
          value={`${(totalStorageUsed / 1024).toFixed(1)} TB`}
        />
        <StatCard
          iconAlt="active-resellers"
          iconSrc="/assets/svg/active-resellers.svg"
          label="Active Resellers"
          value={activeResellers.toString()}
        />
      </div>
      <TableComponent
        columns={columns}
        currentPage={page}
        customRenderCell={renderCell}
        data={paginatedData}
        high="max-h-[calc(100vh-380px)]"
        initialVisibleColumns={['user', 'storageLimit', 'usage', 'status', 'lastActive', 'actions']}
        selectionMode="single"
        showBottomContent={true}
        showTopContent={false}
        total={resellers.length}
        totalPages={totalPages}
        onLimitChange={handleRowsPerPageChange}
        onPageChange={handlePageChange}
      />
    </section>
  )
}

export default Reseller
